import { jsxs as r, jsx as o } from "@emotion/react/jsx-runtime";
import { Fragment as f } from "react";
import { useTheme as S } from "@emotion/react";
import { Layout as x, Title as F, StyledInfiniteScroller as y, StyledSeparator as G } from "./GroupsContent.styled.js";
import { Section as N } from "./Section/Section.js";
import { useBusinessModalContext as v } from "../../BusinessModalContext.js";
import { useGroups as P } from "../../hooks/useGroups.js";
import { NoGroupSection as j } from "./NoGroupSection/NoGroupSection.js";
import { Footer as B } from "./Footer/Footer.js";
const w = () => {
  const {
    translations: i,
    preFilters: s
  } = v(), {
    query: n,
    sections: a
  } = P({
    org_id: s?.searchOrg ?? void 0
  }), {
    fetchNextPage: c,
    hasNextPage: l,
    isFetchingNextPage: m,
    isLoading: p
  } = n, d = S(), h = !!l && !p && !m, e = a?.filter((t) => t?.groups?.length > 0) ?? [], u = e.length > 0;
  return /* @__PURE__ */ r(x, { gap: "0px", children: [
    /* @__PURE__ */ o(F, { variant: "heading4", children: i.groups }),
    /* @__PURE__ */ r(y, { enabled: h, fetchNextPage: c, children: [
      e.map((t, g) => /* @__PURE__ */ r(f, { children: [
        !(g === 0) && /* @__PURE__ */ o(G, { color: d.colors.default.alpha }),
        /* @__PURE__ */ o(N, { section: t })
      ] }, t.id)),
      /* @__PURE__ */ o(j, { hasGroups: u })
    ] }),
    /* @__PURE__ */ o(B, {})
  ] });
};
export {
  w as GroupsContent
};
